import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ROUTES, ROUTE_PATHS } from './config/constants';

// Components
import Header from './components/Header';
import Footer from './components/Footer';
import BdHeader from './components/BdHeader';
import BdFooter from './components/BdFooter';
import CourseDetail from './assets/js/components/CourseDetail';
import ArticleDetail from './assets/js/components/ArticleDetail';
import TalkDetail from './assets/js/components/TalkDetail';
import ProjectDetail from './assets/js/components/ProjectDetail';
import PublicationDetail from './assets/js/components/PublicationDetail';
import AdminRequests from './assets/js/components/AdminRequests';
import BdMovieDetail from './assets/js/components/BdMovieDetail';
import BdSeriesDetail from './assets/js/components/BdSeriesDetail';

// Pages
import Index from './pages/Index';
import BdIndex from './assets/js/pages/BdIndex';
import BdMovies from './assets/js/pages/BdMovies';
import BdSeries from './assets/js/pages/BdSeries';
import BdTags from './assets/js/pages/BdTags';
import BdFavorites from './assets/js/pages/BdFavorites';
import Articles from './assets/js/pages/Articles';
import Projects from './assets/js/pages/Projects';
import Publications from './assets/js/pages/Publications';
import Talks from './assets/js/pages/Talks';
import Courses from './assets/js/pages/Courses';
import Members from './assets/js/pages/Members';
import AdminPage from './assets/js/pages/AdminPage';
import LoginPage from './assets/js/pages/LoginPage';
import BdLoginPage from './assets/js/pages/BdLoginPage';
import BdAdminPage from './assets/js/pages/BdAdminPage';
import BdUserPage from './assets/js/pages/BdUserPage';
import NotFound from './pages/NotFound';

export const AppRoutes = ({ isLoggedIn, isAdmin }) => {
  return (
    <Routes>
      <Route path={ROUTE_PATHS.HOME} element={<Index />} />
      <Route path={ROUTE_PATHS.MEMBERS} element={<Members />} />
      <Route
        path={ROUTE_PATHS.ADMIN}
        element={isAdmin ? <AdminPage /> : <LoginPage />}
      />
      <Route
        path={ROUTE_PATHS.BD_LOGIN}
        element={
          isLoggedIn
            ? isAdmin ? <BdAdminPage /> : <BdUserPage />
            : <BdLoginPage />
        }
      />
      <Route path={ROUTE_PATHS.TALKS} element={<Talks />} />
      <Route path={ROUTE_PATHS.COURSES} element={<Courses />} />
      <Route path={ROUTE_PATHS.PUBLICATIONS} element={<Publications />} />
      <Route path={ROUTE_PATHS.PROJECTS} element={<Projects />} />
      <Route path={ROUTE_PATHS.ARTICLES} element={<Articles />} />
      <Route
        path={ROUTE_PATHS.DETAILS.COURSE}
        element={<CourseDetail />}
      />
      <Route
        path={ROUTE_PATHS.DETAILS.ARTICLE}
        element={<ArticleDetail />}
      />
      <Route
        path={ROUTE_PATHS.DETAILS.TALK}
        element={<TalkDetail />}
      />
      <Route
        path={ROUTE_PATHS.DETAILS.PROJECT}
        element={<ProjectDetail />}
      />
      <Route
        path={ROUTE_PATHS.DETAILS.PUBLICATION}
        element={<PublicationDetail />}
      />
      <Route path={ROUTE_PATHS.BD} element={<BdIndex />} />
      <Route path={ROUTE_PATHS.BD_MOVIES} element={<BdMovies />} />
      <Route path={ROUTE_PATHS.BD_SERIES} element={<BdSeries />} />
      <Route path={ROUTE_PATHS.BD_TAGS} element={<BdTags />} />
      <Route path={ROUTE_PATHS.BD_FAVORITES} element={<BdFavorites />} />
      <Route path={ROUTE_PATHS.BD_REQUESTS} element={<AdminRequests />} />
      <Route
        path={ROUTE_PATHS.DETAILS.MOVIE}
        element={<BdMovieDetail />}
      />
      <Route
        path={ROUTE_PATHS.DETAILS.SERIES}
        element={<BdSeriesDetail />}
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

